import { render, staticRenderFns } from "./LightDownloadFileInfo.vue?vue&type=template&id=5fe5c0b0&scoped=true&"
import script from "../../models/customers/light-downloadFileInfo.ts?vue&type=script&lang=ts&"
export * from "../../models/customers/light-downloadFileInfo.ts?vue&type=script&lang=ts&"
import style0 from "./LightDownloadFileInfo.vue?vue&type=style&index=0&id=5fe5c0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5c0b0",
  null
  
)

export default component.exports